module.exports = __webpack_public_path__ + "img/seta_drt_disable.ea1078d7.svg";